import dicts from './dicts'
import moment from './format/moment'
import duration from './format/duration'
import { flat, valid, tree, map, fill, isString, isFunction, isArray, isObject, isNumber, idCard, saveFile, saveJSON } from './base'
import { getDistrictName } from '@/components/vue-ty/area'

export { isString, isFunction, isArray, isObject, isNumber, fill, valid, tree, rnd, flat, values, saveFile, map, tpl, saveJSON } from './base'
export { moment } from './format/moment'
export { default as duration } from './format/duration'
import distance from './format/distance'
import { getStaticPath } from './request'

export const timestamp = (val) => moment(val, 'timestamp')
export const datetime = (val) => moment(val, 'yyyy-MM-dd hh:mm:ss')
export const time = (val) => moment(val, 'hh:mm:ss')
export const date = (val) => moment(val, 'yyyy-MM-dd')
export const year = (val) => (`${val} 年`)
export const area = d => `${d.province || ''}${d.city || ''}${d.area || ''}`
export const district = d => getDistrictName(d)
export const object = () => ({})
export const left = (val, l = 100) => {
  l = parseInt(l)
  if (!val) return val

  if (val.length < l) {
    return val
  } else {
    return val.substring(0, l) + '...'
  }
}

export const privacy = (val, from, to) => {
  if(!val) return ''
  if( from === 'mobile' ){
    from = 4
    to = 8
  }else if(from === 'idcard'){
    from = 7
    to = 15
  }
  return val.substring(0, from) + ''.padStart(to-from,'*') +  val.substring(to)
}

export const areaSet = (d, src) => {
  let hit = false
  if (!src) {
    src = d.district
    hit = true
  }
  if (src) {
    d.province = src[0] || ''
    d.city = src[1] || ''
    d.area = src[2] || ''
    if (hit) {
      delete d.district
    }
  }
}

export const img = (d) => getStaticPath(d)

const filterFns = { datetime, time, date, year, area, duration,distance, left, img, district , privacy}

const currying = (fn, ...rest) => (v) => fn(v, ...rest)

const filter = (f) => {
  if (typeof f == 'function') {
    return f
  } else if (typeof f == 'string') {
    let [main, ...args] = f.split(':')

    if (filterFns[main]) {
      return currying(filterFns[main], ...args)
    } else if (dicts[f] || dicts[`$${f}`]) {
      let h = map(dicts[f] || dicts[`$${f}`], 'value', 'label')
      return (v) => h[v]
    }

  } else if (Array.isArray(f)) {
    let h = map(f, 'value', 'label')
    return (v) => h[v]
  }
}

/**
 * @param data 待转换数据
 * @param dicts 转换规则
 * @param fix 新字段默认后缀
 * 
 */
export const conv = (data, dicts, fix = 'Text') => {

  let fn
  if (isString(data) || isNumber(data)) {
    fn = filter(dicts)
    if(typeof fn == 'function'){
      return fn(data)
    }else{
      console.log('error dict' , dicts)
    }
  }
  if (isFunction(dicts)) {
    fn = dicts
    if (isArray(data)) {
      data.forEach(i => {
        fn(i)
      })
    } else if (isObject(data)) {
      fn(data)
    }

    return data
  }

  if (!data) return data

  for (let key in dicts) {
    let fn = filter(dicts[key])

    if( !fn ){
      throw new Error('Invalid dict:'+dicts[key]+', key:'+key)
    }

    let [orikey, newkey] = key.split(':')
    if (!newkey) newkey = orikey + fix
    if (isArray(data)) {
      data.forEach(i => {
        if (orikey in i) {
          i[newkey] = fn(i[orikey])
        } else {
          i[orikey] = fn(i)
        }
      })
    } else if (isObject(data)) {
      if (orikey in data) {
        data[newkey] = fn(data[orikey])
      } else {
        data[orikey] = fn(data)
      }
    }
  }

  return data
}



export const merge = (data, dicts) => {
  if (!data) return data
  for (let src in dicts) {
    let dist = dicts[src]
    if (Array.isArray(data)) {
      data.forEach(i => {
        if (src in i && i[src] !== null) {
          i[dist] = i[src]
        }
      })
    }
  }

  return data
}

export const extend = (dist, src) => {
  for (let i in src) {
    if (!dist[i]) {
      dist[i] = src[i]
    }
  }
  return dist
}

export const debounce = (func, wait, immediate) => {
  let timeout, result;
  return () => {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) result = func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) result = func.apply(context, args);
    return result;
  };
};

export const link = (arr, insert) => arr.reduce((t, c, idx, arr) => t.concat(idx > 0 ? [insert, c] : [c]), [])

export const value2label = (data, value) => {
  let label = ''
  data.forEach(item => {
    if (String(item.value) === String(value)) {
      label = item.label
    }
  })
  return label
}

export const filterSearch = (params) => {
  // 搜索值过滤
  let search = JSON.parse(JSON.stringify(params))
  for (let key in search) {
    let v = String(search[key])
    if (v === '' || v === 'null' || v === 'undefined') {
      delete search[key]
    } else if (search[key] instanceof Array) {
      search[key] = search[key]
    } else if (search[key] instanceof Object) {
      search[key] = search[key]
    } else {
      search[key] = v.trim()
    }
  }
  return search
}

export default { conv, areaSet, time, date, idCard, datetime, fill, tree, flat, merge, valid, map, extend, saveFile, link, value2label, filterSearch, saveJSON }
